import { HttpInterceptorFn } from '@angular/common/http';
import { BasicConstants } from '../constants/basics-constant';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  // let companyCodeStore = localStorage.getItem(BasicConstants.COMPANY_CODE) ?? '';

  let lang = localStorage.getItem(BasicConstants.LANG);
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${localStorage.getItem(BasicConstants.USER_TOKEN)}`,
      'Accept-Language': lang == 'ar' ? 'ar-EG' : 'en-US',
    },
  });
  return next(authReq);
};
